<template>
  <div class="grid gap-12 w-full">
    <TeamCard
      v-for="(author, index) in data"
      :key="index"
      :author="author"
    />
  </div>
</template>

<script lang="ts" setup>
const limit = ref(10)
const sort = ref({ order: 1, $numeric: true })
const { data } = await useAsyncData('collections-all-authors',
  () => queryContent<TeamMember>('/author').limit(limit.value).sort(sort.value).find(),
  { transform: data => correctAssetRoutes(data),
    watch: [limit, sort],
  },
)

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
</script>

<style scoped>

</style>
